"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = (0, tslib_1.__importDefault)(require("react"));
var prop_types_1 = (0, tslib_1.__importDefault)(require("prop-types"));
var lodash_1 = require("lodash");
var key_codes_1 = (0, tslib_1.__importDefault)(require("../../../constants/key-codes"));
var KeyboardNavigation = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(KeyboardNavigation, _super);
    function KeyboardNavigation(props) {
        var _this = _super.call(this, props) || this;
        _this._handleKeydown = function (event) {
            if (event.keyCode === key_codes_1.default.LEFT) {
                _this.props.onKeyboardArrowLeft();
            }
            if (event.keyCode === key_codes_1.default.RIGHT) {
                _this.props.onKeyboardArrowRight();
            }
        };
        _this.handleKeydown = (0, lodash_1.throttle)(_this._handleKeydown, props.throttle);
        return _this;
    }
    KeyboardNavigation.prototype.componentDidMount = function () {
        document.body.addEventListener('keydown', this.handleKeydown);
    };
    KeyboardNavigation.prototype.componentWillUnmount = function () {
        document.body.removeEventListener('keydown', this.handleKeydown);
        this.handleKeydown.cancel();
    };
    KeyboardNavigation.prototype.render = function () {
        return null;
    };
    KeyboardNavigation.propTypes = {
        onKeyboardArrowLeft: prop_types_1.default.func.isRequired,
        onKeyboardArrowRight: prop_types_1.default.func.isRequired,
        throttle: prop_types_1.default.number,
    };
    KeyboardNavigation.defaultProps = {
        throttle: 200,
    };
    return KeyboardNavigation;
}(react_1.default.Component));
exports.default = KeyboardNavigation;
//# sourceMappingURL=keyboard-navigation.js.map